



import React, { useEffect } from 'react'
// import CustomTable from '../../Components/Table/CustomTable';

import { Grid } from '@mui/material';

import { useDispatch } from 'react-redux';
import CustomTable from '../../../../Components/Table/CustomTable';
import AllUserTableViewModal from '../../../OperatorRegistration/Modal/AllUserTableViewModal';
import TableDataViewModal from '../../Modal/TableDataViewModal';
// import { setHeaderName } from '../../../ReduxStore/Slices/headerSlice';
// import { setHeaderName } from './headerSlice';


const TotalNetBankingTransactionComplete = () => {

    const tableData = [
        { Name: 'Vallarasu', UserType: "Individual", SchemeBought:"Scheme1",Payment:"USD 1000",Status: "Completed" },
        { Name: 'Pravin',  UserType: "Individual", SchemeBought:"Scheme1",Payment:"USD 1000",Status: "Completed" },
        { Name: 'Shahul', UserType: "Individual", SchemeBought:"Scheme1",Payment:"USD 1000",Status: "Completed" },
        { Name: 'Ramesh', UserType: "Individual", SchemeBought:"Scheme1",Payment:"USD 1000",Status: "Completed" },
        { Name: 'Sanjeev',UserType: "Financial Consultant", SchemeBought:"Scheme1",Payment:"USD 1000",Status: "Completed" },

        { Name: 'Vallarasu',  UserType: "Individual", SchemeBought:"Scheme1",Payment:"USD 1000",Status: "Completed" },
        { Name: 'Pravin',  UserType: "Individual", SchemeBought:"Scheme1",Payment:"USD 1000",Status: "Completed" },
        { Name: 'Shahul', UserType: "Individual", SchemeBought:"Scheme1",Payment:"USD 1000",Status: "Completed" },
        { Name: 'Ramesh',  UserType: "Individual", SchemeBought:"Scheme1",Payment:"USD 1000",Status: "Completed" },
        { Name: 'Sanjeev', UserType: "Financial Consultant", SchemeBought:"Scheme1",Payment:"USD 1000",Status: "Completed" },


    ];
    
    const tableHeadData = ['S.No', 'Name', "Email", "Mobile Number", "User Type", 'Status'];

    return (
        <Grid container spacing={2}>

            <Grid item xs={12} sx={{ width: "100px" }}>
                <CustomTable tableData={tableData} title="User List" tableHeadData={tableHeadData}
                    rowPerPage={10}
                    tableView="tableView"
                    tableSearch="tableSearch"
                    dataCreate="dataCreate"
                    // tableEdit="tableEdit"
                    // tableDelete="tableDelete"
                    // modalName={UserCreateByOperatorModal}
                    allShowModal="allShowModal"
                    modalVeiwName={TableDataViewModal}
                    modalViewHeadingName="User Detail"

                    modalHeadingName="Create User"
                />

            </Grid>
        </Grid>
    )
}

export default TotalNetBankingTransactionComplete